export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'SURGERIES': 'Surgeries',
            'NEWSURGERIES': 'New Surgery',
            'CONTINUESURGERIES': 'Continue Surgery',
            'WATCHSURGERIES': 'Watch Surgery',
            'CONSOLE': 'Console',


            'SAMPLE'        : {
                'TITLE': 'Sample',
                'BADGE': '25'
            }
        }
    }
};



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/navigation/i18n/en.ts